/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { NavigationMockApi } from './api';



export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'Accueil',
        title: 'Accueil',
        type : 'basic',
        //icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    }
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'Accueil',
        title: 'Accueil',
        type : 'basic',
        //icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    }
];

function executeActionBeforeLeavingCustomerDetails(uri): void {
    NavigationMockApi.executeActionBeforeLeavingCustomerDetails(uri);       
}

function hasPermission(redirectURL : string): boolean {
    if (NavigationMockApi.userPermissions?.length > 0) {
        let filtredPermissions = NavigationMockApi.userPermissions.filter(x => x.pageRoute == redirectURL);
        if (filtredPermissions.length > 0) {
            return true;
        } else {
            return false;
        }
        } else {     
        return false;
        }
}

function isAdminPartner() {
    return NavigationMockApi.user_UserProfiles.some(
        profile => 
          profile?.userProfile?.name === 'Admin E. Partenaire'
      );
}
